import { render, staticRenderFns } from "./RecurrentWithdrawal.vue?vue&type=template&id=70d20b30&scoped=true&"
import script from "./RecurrentWithdrawal.vue?vue&type=script&lang=js&"
export * from "./RecurrentWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d20b30",
  null
  
)

export default component.exports